import React, { useEffect, useState } from "react";
import Select from "react-select";
import { useFormikContext } from "formik";
import { useOutletContext } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  reqToGetmodulesList,
  reqToGetPlanList,
} from "../../redux/slices.js/plans/plansSlice";

const plans = [
  { id: "freeTrial", name: "Free Trial", price: "$0/month", users: "7 days" },
  {
    id: "starter",
    name: "Starter",
    price: "$299/month",
    users: "Up to 7 users",
  },
  {
    id: "professional",
    name: "Professional",
    price: "$599/month",
    users: "Up to 50 users",
  },
  {
    id: "enterprise",
    name: "Enterprise",
    price: "Custom",
    users: "Up to unlimited users",
  },
];

const items = [
  "Leave management",
  "Roster management",
  "Performance Reviews",
  "Recruitment",
  "Time and attendance",
  "Onboarding",
  "Payroll",
  "Learning & Development",
  "Performance Reviews",
];

const billingCycles = [
  { label: "Monthly", value: "monthly" },
  { label: "Quarterly", value: "quarterly" },
  { label: "Annually", value: "annually" },
];

const PlansModules = () => {
  const dispatch = useDispatch();
  const { values, errors, touched, handleChange, setFieldValue } =
    useFormikContext();

  const { isSidebarOpen } = useOutletContext();
  const [plans, setPlans] = useState([]);
  const [modules, setModules] = useState();

  useEffect(() => {
    dispatch(
      reqToGetPlanList({
        data: {},
        onSuccess: (res) => {
          setPlans(res?.data || []);
        },
        onFailure: (err) => {
          console.error("Failed to fetch plans:", err);
        },
      })
    );
    dispatch(
      reqToGetmodulesList({
        data: {},
        onSuccess: (res) => {
          setModules(res?.data || []);
        },
        onFailure: (err) => {
          console.error("Failed to fetch modules:", err);
        },
      })
    );
  }, [dispatch]);

  const handleRadioChange = (planId) => {
    setFieldValue("selectedPlan", planId);
  };

  const handleModuleToggle = (moduleId, isChecked) => {
    let updatedModules;

    if (isChecked) {
      // Add the module object to the array
      const moduleToAdd = modules.find((m) => m.id === moduleId);
      updatedModules = [...values.enabledModules, moduleToAdd];
    } else {
      // Remove the module object from the array by comparing IDs
      updatedModules = values.enabledModules.filter((m) => m.id !== moduleId);
    }

    setFieldValue("enabledModules", updatedModules);
  };

  return (
    <section className="space-y-8 flex-1">
      <div className="form-group">
        <label>
          Select Plan <span>*</span>
        </label>
        <div
          className={`grid gap-3 sm:grid-cols-2 ${
            isSidebarOpen ? "lg:grid-cols-2" : ""
          }  lg:grid-cols-4 mt-4`}
        >
          {plans.map((plan) => (
            <div
              key={plan.id}
              className={`p-6 bg-white shadow-[0_4px_32px_0_#0000000D] rounded-lg flex flex-col ${
                errors.selectedPlan && touched.selectedPlan
                  ? "border border-red-500"
                  : ""
              }`}
            >
              <div className="flex justify-between items-start gap-1 flex-1">
                <div className="">
                  <h3 className={`text-span !font-medium text-black mb-0`}>
                    {plan.name}
                  </h3>
                  <p className="text-[#9BA2AB] text-span mb-0">
                    {plan.name === "Prime"
                      ? "Up to Unlimited users"
                      : `Up to ${plan.max_active_users} users`}
                  </p>
                </div>
                <label className="flex items-center gap-3 cursor-pointer select-none mb-4 relative">
                  <input
                    type="radio"
                    name="selectedPlan"
                    checked={values.selectedPlan === plan.id}
                    onChange={() => handleRadioChange(plan.id)}
                    className="peer hidden"
                  />
                  <span className="flex h-5 w-5 items-center justify-center rounded-full border-2 border-[#9BA2AB] peer-checked:border-[#4285F4] peer-checked:bg-[#4285F4] bg-white">
                    {values.selectedPlan === plan.id && (
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="h-4 w-4 text-blue-500"
                        fill="#fff"
                        viewBox="0 0 20 20"
                      >
                        <path
                          fillRule="evenodd"
                          d="M16.707 5.293a1 1 0 00-1.414 0L9 11.586 6.707 9.293a1 1 0 00-1.414 1.414l3 3a1 1 0 001.414 0l7-7a1 1 0 000-1.414z"
                          clipRule="evenodd"
                        />
                      </svg>
                    )}
                  </span>
                </label>
              </div>
              <p className="text-h2 Rubik text-blue-100 !font-bold mb-0 mt-7">
                $ {plan.price} <span>/Month</span>
              </p>
            </div>
          ))}
        </div>
        {errors.selectedPlan && touched.selectedPlan && (
          <div className="error-message">{errors.selectedPlan}</div>
        )}
      </div>

      <div className="form-group">
        <label>
          Enable modules <span>*</span>
        </label>
        <div className="grid gap-3 gap-y-5 md:grid-cols-2 lg:grid-cols-3 mt-4">
          {modules?.map((item, index) => (
            <label
              key={index}
              className="flex items-center gap-3 cursor-pointer select-none"
            >
              <div className="relative flex items-center justify-center">
                <input
                  type="checkbox"
                  checked={values.enabledModules.some((m) => m.id === item.id)}
                  onChange={(e) =>
                    handleModuleToggle(item.id, e.target.checked)
                  }
                  className="peer hidden"
                />
                <span className="flex h-5 w-5 items-center justify-center rounded border-2 border-[#9BA2AB] peer-checked:border-[#4285F4] bg-white peer-checked:bg-white transition-colors">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className={`h-3 w-3 text-[#4285F4] ${
                      values.enabledModules.some((m) => m.id === item.id)
                        ? "block"
                        : "hidden"
                    }`}
                    viewBox="0 0 20 20"
                    fill="currentColor"
                  >
                    <path
                      fillRule="evenodd"
                      d="M16.707 5.293a1 1 0 00-1.414 0L9 11.586 6.707 9.293a1 1 0 00-1.414 1.414l3 3a1 1 0 001.414 0l7-7a1 1 0 000-1.414z"
                      clipRule="evenodd"
                    />
                  </svg>
                </span>
              </div>
              <div className="text-black text-span !leading-[15px] !tracking-[0]">
                {item?.name}
              </div>
            </label>
          ))}
        </div>
        {errors.enabledModules && touched.enabledModules && (
          <div className="error-message">{errors.enabledModules}</div>
        )}
      </div>

      <div className="form-group">
        <label>
          Billing Cycle <span>*</span>
        </label>
        <div className="flex space-x-4 items-center mt-4">
          {billingCycles.map((cycle) => (
            <label
              key={cycle.value}
              className="flex items-center cursor-pointer"
            >
              <input
                type="radio"
                name="billingCycle"
                value={cycle.value}
                checked={values.billingCycle === cycle.value}
                onChange={handleChange}
                className="hidden"
              />
              <span
                className={`w-5 h-5 rounded-full border-2 ${
                  values.billingCycle === cycle.value
                    ? "bg-blue-500 border-blue-500"
                    : "bg-white border-gray-300"
                } flex items-center justify-center`}
              >
                {values.billingCycle === cycle.value && (
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="h-4 w-4 text-blue-500"
                    fill="#fff"
                    viewBox="0 0 20 20"
                  >
                    <path
                      fillRule="evenodd"
                      d="M16.707 5.293a1 1 0 00-1.414 0L9 11.586 6.707 9.293a1 1 0 00-1.414 1.414l3 3a1 1 0 001.414 0l7-7a1 1 0 000-1.414z"
                      clipRule="evenodd"
                    />
                  </svg>
                )}
              </span>
              <div className="ml-2 text-black text-span">{cycle.label}</div>
            </label>
          ))}
        </div>
        {errors.billingCycle && touched.billingCycle && (
          <div className="error-message">{errors.billingCycle}</div>
        )}
      </div>
    </section>
  );
};

export default PlansModules;
